import { Button, ComplexCard } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import type * as React from 'react'
import type { CSSProperties } from 'react'

type NextReviewCardProps = {
  nextReviewDate?: string
  onReview?: () => void
  style: CSSProperties
  translate: (id: string, variable?: any) => string
}

export const NextReviewCard = ({
  nextReviewDate,
  onReview,
  style,
  translate
}: NextReviewCardProps): React.ReactElement => (
  <ComplexCard
    localisation={{
      title: nextReviewDate
        ? translate('nextReview')
        : translate('noReviewSet'),
      review: translate('review')
    }}
    dateValue={
      (nextReviewDate && dayjs(nextReviewDate).format('DD-MM-YYYY')) || ''
    }
    style={style as CSSProperties}
    rightChildren={
      !!onReview && (
        <Button variant="primary" onClick={onReview}>
          {translate('review')}
        </Button>
      )
    }
  />
)

export default NextReviewCard
